'use client'

import { ComponentProps } from 'react'

import { OfferMessage as BaseOfferMessage } from '@marketplace-web/offers/price-offers-feature'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import { isDateInTheFuture } from '../../../utils/date'

type Props = Pick<ComponentProps<typeof BaseOfferMessage>, 'message' | 'createdTime' | 'entityType'>

const OfferMessage = (props: Props) => {
  const { conversation, transaction } = useConversationContext()

  if (!conversation) return null
  if (!conversation.oppositeUser) return null
  if (!conversation.transactionId) return null

  return (
    <BaseOfferMessage
      {...props}
      transactionId={conversation.transactionId}
      oppositeUser={conversation.oppositeUser}
      isPaymentActionAvailable={conversation.isPaymentActionAvailable}
      isSellerCountdownActive={Boolean(
        isDateInTheFuture(transaction?.seller?.closetCountdownEndDate),
      )}
      buyerId={conversation.buyerId}
    />
  )
}

export default OfferMessage
